import { createI18n } from "vue-i18n";
import translation from "../i18n/translation";

const initialLocale = "en"

// document.querySelector("html").setAttribute("lang", initialLocale);
const i18n = createI18n(translation(initialLocale));

export default i18n;
